var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.17 31.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    stroke: "#016846",
    strokeMiterlimit: 10,
    x: 0.5,
    y: 11.55,
    width: 24.17,
    height: 19.49,
    rx: 2.26,
    ry: 2.26
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#016846",
    d: "M14.67,19.36c0,.8-.45,1.5-1.11,1.85v4.28h-1.94v-4.27c-.66-.36-1.12-1.06-1.12-1.86,0-1.15.94-2.08,2.09-2.08s2.08.93,2.08,2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#016846",
    strokeMiterlimit: 10,
    d: "M19.67,11.55v-3.85c0-3-1.79-5.81-4.62-6.8-.57-.2-1.18-.33-1.8-.38-1.41-.11-2.8.21-4.01.87-2.26,1.23-3.55,3.71-3.55,6.28v3.88h13.98Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.bff3f786e808370804ba8f05c950adc2.svg";
export { ForwardRef as ReactComponent };